'use client'

import styled from "styled-components";
import {Modal} from "antd";
import {getSizeStyles} from "@/components/UI/Containers/Modal/options/size.options";

export const ModalStyled = styled(Modal)`
    .ant-modal-content {
        padding: clamp(10px, 5vw, 40px) clamp(30px, 4vw, 80px);
        text-align: center;
        border-radius: 20px;

        ${({$hideClose}) => $hideClose && `
        .ant-modal-close {
            display: none;
        }
    `}
    }

    ${getSizeStyles}
`

export const ModalHeader = styled.div``

export const ModalBody = styled.div``